import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Header from './Header';
import PdfUpload from './PdfUpload';

function App() {
  return (
    <div className="App">
      <Header />
      <PdfUpload />
    </div>
  );
}

export default App;